import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { SideBarWrapper, SideBarTitle, SideBarLogo, FooterSideBar } from './SideBar.styles';
import { BarSteppers } from '../SideBarSteppers/SideBarSteppers';

import SocialLink from '../SocialLinks/SocialLinks';
import { useAppSelector } from '@app/hooks';
export interface SideBarProps {
  variant: 'primary' | 'secondary' | 'default';
}
export const SideBar: FC<SideBarProps> = ({ variant }) => {
  let templateConfig = useAppSelector((state) => state.TemplateConfig);
  const [loading, setLoading] = useState(!templateConfig?.lenderId);
  const logo = templateConfig?.globalTheme?.logo;
  const componentSideBarColor = templateConfig?.globalTheme?.sidebarColorHeader ?? '#ffffff';

  useEffect(() => {
    if (Object.keys(templateConfig).length && templateConfig?.lenderId) {
      setLoading(false);
    }
  }, [templateConfig]);

  if (loading) {
    return null;
  }

  return (
    <SideBarWrapper $variant={variant} data-testid="side-bar">
      <SideBarLogo>
        <img src={logo} alt={`${templateConfig?.lenderName} logo - go to get started`} onClick={() => window.location.assign('/get-started')} />
      </SideBarLogo>
      <SideBarTitle $variant={variant} $color={componentSideBarColor} data-testid="side-bar-title">
        Know Your Home's Equity
      </SideBarTitle>
      <BarSteppers variant={variant} color={componentSideBarColor} />
      <FooterSideBar data-testid="social-link">
        <SocialLink socialLinks={templateConfig?.pages?.socialLinks || []} />
      </FooterSideBar>
    </SideBarWrapper>
  );
};
